import {
  instance as axios,
  setJwtToken,
  setMultiPartHeader,
} from "../../config/axiosInstance";

// Revenue Analytics API
export const fetchRevenueAnalyticsApi = async (data) => {
  const endPoint = `/admin/dashboard/revenue-analytics` +
    "?" +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};


// Consultant Performance API
export const fetchConsultantPerformanceApi = async (data) => {
  const endPoint = `/admin/enhanced-dashboard/consultant-performance` +
    "?" +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

// Real-time Analytics API
export const fetchRealtimeAnalyticsApi = async () => {
  const endPoint = `/admin/enhanced-dashboard/realtime-analytics`;
  return await axios.get(endPoint, setJwtToken());
};

// Service Distribution API
export const fetchServiceDistributionApi = async (data) => {
  const endPoint = `/admin/enhanced-dashboard/service-distribution` +
    "?" +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

// User Growth Trends API
export const fetchUserGrowthTrendsApi = async (data) => {
  const endPoint = `/admin/enhanced-dashboard/user-growth-trends` +
    "?" +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

// Consultant Earnings API
export const fetchConsultantEarningsApi = async (data) => {
  const endPoint = `/admin/enhanced-dashboard/consultant-earnings` +
    "?" +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

// Session Analytics API
export const fetchSessionAnalyticsApi = async (data) => {
  const endPoint = `/admin/enhanced-dashboard/session-analytics` +
    "?" +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

// Support Analytics API
export const fetchSupportAnalyticsApi = async (data) => {
  const endPoint = `/admin/enhanced-dashboard/support-analytics` +
    "?" +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

// Test API
export const testDashboardApi = async () => {
  const endPoint = `/admin/test-dashboard/test`;
  return await axios.get(endPoint, setJwtToken());
};

// Quick Stats API
export const fetchQuickStatsApi = async (data) => {
  const endPoint = `/admin/dashboard/quick-stats` +
    "?" +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

// Last 10 Days Data API
export const fetchLast10DaysDataApi = async (data) => {
  const endPoint = `/admin/dashboard/last-10-days-data` +
    "?" +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

export const fetchHourlyBreakdownApi = async (data) => {
  const endPoint = `/admin/dashboard/hourly-breakdown` +
    "?" +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

export const fetchRegistrationRechargeFunnelApi = async (data) => {
  const endPoint = `/admin/dashboard/registration-recharge-funnel` +
    "?" +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};


export const fetchLastDaysDataApiGroup  = async (data) => {
 const endPoint = `/admin/dashboard/daily-group-performance` +
    "?" +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
}

// Daily Consultant Performance (consultant-wise, grouped A → B → C → N → Dead)
export const fetchLastDaysDataApiConsult = async (data) => {
  const endPoint =
    `/admin/dashboard/daily-consultant-performance` +
    "?" +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};



export const fetchUserAnalyticsApi = async (data) => {
  const endPoint = `/admin/dashboard/user-analytics` +
    "?" +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

// User and Consultant Online Gap API
export const fetchUserConsultantOnlineGapApi = async (data) => {
  const endPoint = `/admin/dashboard/user-consultant-online-gap` +
    "?" +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

// Top Consultant Performance API (based on total completed consultations)
export const fetchTopConsultantPerformanceApi = async (data) => {
  const endPoint = `/admin/dashboard/top-consultant-performance` +
    "?" +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

// Top Consultant Performance by Online Time API (based on busy time percentage)
export const fetchTopConsultantOnlineTimeApi = async (data) => {
  const endPoint = `/admin/dashboard/top-consultant-online-time` +
    "?" +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};
